import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { FieldFilter } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getFieldFilters: QueryFunction<
  FieldFilter[],
  ['/field-filters']
> = async () => {
  if (isMockServices()) return await mock(_mockFieldFilters);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    filters: FieldFilter[];
  }>('/search-filters?type=field', {
    method: 'GET',
  });
  if (response.data) return response.data.filters;
  throw new Error('Failed to fetch field filters');
};

export default getFieldFilters;

export const _mockFieldFilters: FieldFilter[] = [
  { id: '1', name: 'Marksman - Inquiry', isOrganization: false },
  { id: '2', name: 'Loan Officer - LO', isOrganization: true },
  { id: '3', name: 'Loan Processor - LP', isOrganization: true },
];
